import { authAdapter } from "@/core/auth/adapter";
import { RouterProvider, createRouter } from "@tanstack/react-router";
import ReactDOM from "react-dom/client";
import UrqlProvider from "./providers/UrqlProvider.tsx";
import reportWebVitals from "./reportWebVitals.ts";
import { routeTree } from "./routeTree.gen";
import "./styles.css";
import "./styles/portal/tokens.css";
import "./styles/portal/bundle.css";
import "./styles/portal/overrides.css";

export const router = createRouter({
	routeTree,
	context: { authAdapter },
	defaultPreload: "intent",
	scrollRestoration: true,
	defaultStructuralSharing: true,
	defaultPreloadStaleTime: 0,
});

declare module "@tanstack/react-router" {
	interface Register {
		router: typeof router;
	}
}

const rootElement = document.getElementById("app");
if (rootElement && !rootElement.innerHTML) {
	ReactDOM.createRoot(rootElement).render(
		<UrqlProvider>
			<RouterProvider router={router} />
		</UrqlProvider>,
	);
}

reportWebVitals();
